import { render, staticRenderFns } from "./newsRow.vue?vue&type=template&id=01e7b3fb&scoped=true&"
import script from "./newsRow.vue?vue&type=script&lang=js&"
export * from "./newsRow.vue?vue&type=script&lang=js&"
import style0 from "./newsRow.vue?vue&type=style&index=0&id=01e7b3fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e7b3fb",
  null
  
)

export default component.exports